import { useState, useEffect } from 'react';

interface Settings {
  faviconUrl?: string;
  pageTitle?: string;
  iconUrl?: string;
  logoUrl?: string;
  companyName?: string;
}

export function useGlobalSettings() {
  const [settings, setSettings] = useState<Settings | null>(null);

  const loadSettings = async () => {
    try {
      // Usar rota pública que não requer autenticação com cache busting
      const response = await fetch('/api/settings/public?v=' + Date.now(), {
        cache: 'no-cache',
        headers: {
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache'
        }
      });

      if (response.ok) {
        const data = await response.json();
        setSettings({
          faviconUrl: data.faviconUrl,
          pageTitle: data.pageTitle,
          iconUrl: data.iconUrl,
          logoUrl: data.logoUrl,
          companyName: data.companyName
        });
      }
    } catch (err) {
      console.log('Não foi possível carregar configurações globais:', err);
    }
  };

  useEffect(() => {
    loadSettings();

    // Recarregar configurações a cada 30 segundos para detectar mudanças
    const interval = setInterval(loadSettings, 30000);

    return () => clearInterval(interval);
  }, []);

  return {
    settings,
    refetch: loadSettings
  };
}